import { portalApi } from "../../../store/generated/portal/brief-tokens";
import { DebriefScheduleApiTags } from "./debriefScheduleApi";

export enum BriefTokenApiTags {
  BriefTokens = "BriefTokens",
  DebriefSchedules = DebriefScheduleApiTags.DebriefSchedules,
}

// Enhance the generated API with custom tags
const taggedApi = portalApi.enhanceEndpoints({
  addTagTypes: [BriefTokenApiTags.BriefTokens, BriefTokenApiTags.DebriefSchedules],
  endpoints: {
    // Add tag invalidation to generated endpoints
    portalBriefTokensList: {
      providesTags: [BriefTokenApiTags.BriefTokens],
    },
    portalBriefTokensRetrieve: {
      providesTags: (result, error, arg) => [
        { type: BriefTokenApiTags.BriefTokens, id: arg.id }
      ],
    },
    portalBriefTokensCreate: {
      invalidatesTags: [BriefTokenApiTags.BriefTokens, BriefTokenApiTags.DebriefSchedules],
    },
    portalBriefTokensUpdate: {
      invalidatesTags: (result, error, arg) => [
        { type: BriefTokenApiTags.BriefTokens, id: arg.id },
        BriefTokenApiTags.BriefTokens,
        BriefTokenApiTags.DebriefSchedules
      ],
    },
    portalBriefTokensPartialUpdate: {
      invalidatesTags: (result, error, arg) => [
        { type: BriefTokenApiTags.BriefTokens, id: arg.id },
        BriefTokenApiTags.BriefTokens,
        BriefTokenApiTags.DebriefSchedules
      ],
    },
    portalBriefTokensDestroy: {
      invalidatesTags: [BriefTokenApiTags.BriefTokens, BriefTokenApiTags.DebriefSchedules],
    },
    apiPortalV1BriefTokensHardDeleteCreate: {
      invalidatesTags: [BriefTokenApiTags.BriefTokens, BriefTokenApiTags.DebriefSchedules],
    },
    apiPortalV1BriefTokensRestoreCreate: {
      invalidatesTags: [BriefTokenApiTags.BriefTokens, BriefTokenApiTags.DebriefSchedules],
    },
  },
});

// Export the enhanced API as briefTokenApi
export const briefTokenApi = taggedApi;

// Re-export all the generated hooks with the enhanced tags
export const {
  usePortalBriefTokensListQuery,
  usePortalBriefTokensCreateMutation,
  usePortalBriefTokensRetrieveQuery,
  usePortalBriefTokensUpdateMutation,
  usePortalBriefTokensPartialUpdateMutation,
  usePortalBriefTokensDestroyMutation,
  useApiPortalV1BriefTokensHardDeleteCreateMutation,
  useApiPortalV1BriefTokensRestoreCreateMutation,
} = briefTokenApi;

// Legacy hook aliases for convenience
export const useGetBriefTokensQuery = usePortalBriefTokensListQuery;
export const useGetBriefTokenQuery = usePortalBriefTokensRetrieveQuery;
export const useCreateBriefTokenMutation = usePortalBriefTokensCreateMutation;
export const useUpdateBriefTokenMutation = usePortalBriefTokensPartialUpdateMutation;
export const useDeleteBriefTokenMutation = usePortalBriefTokensDestroyMutation;
export const useCancelBriefTokenMutation = usePortalBriefTokensPartialUpdateMutation;
